export default "https://static-tg.3jyx.cn/mallfe/_next/static/images/service-head-349fa5538282dc2d540367a88c17ef43.png";